export const tickerItems = [
  '某短剧平台分账争议：编剧方与平台各执一词，双方时间线已核对',
  '某连锁餐饮加盟纠纷：前加盟商集体发声，品牌方回应已挂出',
  '某选秀节目剪辑争议：现场观众视角流出，正片与路透存在出入',
  '某直播带货退款事件：平台先行垫付，涉事账号状态仍在更新',
  '某院线影片票房数据异常：第三方监测与片方口径不一致',
  '某音乐节退票风波：主办方公布补偿方案，部分观众仍存疑',
  '某联名周边发货延迟：预售说明与实物规格出现出入',
  '某赛事裁判判罚争议：官方复核结论与选手说法仍有分歧',
];

export const siteStats = [
  { value: '128', label: '今日新增条目' },
  { value: '3,742', label: '已收录事件' },
  { value: '96', label: '待证实' },
  { value: '511', label: '已有结论' },
];

export const quickEntries = [
  { label: '全部事件', count: '3742', icon: 'ri-apps-2-line' },
  { label: '今日热度', count: '128', icon: 'ri-fire-line' },
  { label: '争议中', count: '204', icon: 'ri-question-line' },
  { label: '扒皮纪实', count: '88', icon: 'ri-search-eye-line' },
  { label: '已出实锤', count: '511', icon: 'ri-shield-check-line' },
  { label: '时间线整理', count: '326', icon: 'ri-time-line' },
];

export const hotRanking = [
  {
    rank: '01',
    title: '某短剧平台分账风波：编剧署名与收益分配的双向质证',
    summary:
      '从合同截图、聊天记录到平台公告，三方说法在关键时间点上出现三处矛盾，收益口径成为争议核心。',
    heat: '98.6万',
    trend: 'up',
    tag: '争议中',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20peach%20and%20coral%20toned%20editorial%20abstract%20still%20life%20on%20a%20cream%20background%2C%20stacked%20paper%20cards%20and%20folded%20fabric%2C%20soft%20diffused%20studio%20lighting%2C%20subtle%20film%20grain%2C%20premium%20magazine%20aesthetic%2C%20calm%20harmonious%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=450&seq=peach-rank-01&orientation=landscape',
  },
  {
    rank: '02',
    title: '某连锁餐饮加盟纠纷：前加盟商的集体陈述与品牌回应',
    summary:
      '27 位前加盟商整理出统一诉求清单，品牌侧回应加盟条款与亏损归因，双方均强调自己掌握完整证据。',
    heat: '87.2万',
    trend: 'up',
    tag: '扒皮纪实',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20apricot%20toned%20editorial%20abstract%20composition%20on%20creamy%20beige%20backdrop%2C%20geometric%20paper%20blocks%20and%20a%20small%20ceramic%20cup%2C%20gentle%20window%20light%2C%20fine%20grain%20texture%2C%20quiet%20luxury%20magazine%20layout%20feel%2C%20balanced%20negative%20space%2C%20no%20text&width=600&height=450&seq=peach-rank-02&orientation=landscape',
  },
  {
    rank: '03',
    title: '某选秀节目剪辑争议：现场视角与正片呈现的差异清单',
    summary:
      '观众整理出 11 处剪辑差异点，节目组回应称属于播出节奏需要，完整素材暂不公开。',
    heat: '75.4万',
    trend: 'flat',
    tag: '争议中',
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20blush%20pink%20editorial%20abstract%20flat%20lay%20on%20warm%20cream%20surface%2C%20minimal%20paper%20strips%20and%20dried%20flower%20petals%2C%20soft%20top%20lighting%2C%20delicate%20grain%2C%20refined%20magazine%20quality%2C%20gentle%20harmonious%20tones%2C%20no%20text&width=600&height=450&seq=peach-rank-03&orientation=landscape',
  },
  {
    rank: '04',
    title: '直播带货退款事件复盘：垫付方案、账号状态与后续处理',
    summary:
      '平台先行垫付后公布退款进度表，涉事账号尚未恢复更新，部分用户仍在梳理自己的订单凭证。',
    heat: '63.9万',
    trend: 'down',
    tag: '有结论',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20terracotta%20and%20cream%20editorial%20still%20life%2C%20layered%20matte%20paper%20and%20a%20wooden%20block%2C%20soft%20directional%20light%2C%20subtle%20film%20grain%2C%20understated%20premium%20magazine%20aesthetic%2C%20organized%20minimal%20composition%2C%20no%20text&width=600&height=450&seq=peach-rank-04&orientation=landscape',
  },
  {
    rank: '05',
    title: '票房数据异常争议：第三方监测与片方口径对照',
    summary:
      '两份数据在同一时段的增速曲线明显不同，第三方称方法公开，片方表示统计口径存在差异。',
    heat: '52.1万',
    trend: 'up',
    tag: '待证实',
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20honey%20amber%20editorial%20abstract%20scene%20on%20pale%20cream%20background%2C%20overlapping%20translucent%20paper%20sheets%20and%20a%20small%20brass%20clip%2C%20mild%20studio%20lighting%2C%20fine%20grain%2C%20elegant%20magazine%20cover%20mood%2C%20soft%20shadows%2C%20no%20text&width=600&height=450&seq=peach-rank-05&orientation=landscape',
  },
];

export const feedFilters = ['全部', '今日更新', '争议中', '扒皮纪实', '待证实', '已有结论'];

export const updateFeed = [
  {
    time: '12 分钟前',
    filter: '今日更新',
    title: '某音乐节退票风波：主办方补偿方案逐条解读',
    summary:
      '补偿方案共 4 条，涵盖改期、退票与补偿券三种处理方式，观众关心的手续费问题被单独说明。',
    tags: ['时间线整理', '官方回应'],
    heat: '4.8万',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20peach%20editorial%20abstract%20detail%20on%20a%20cream%20surface%2C%20curled%20paper%20edge%20and%20soft%20cloth%20texture%2C%20gentle%20diffused%20light%2C%20subtle%20grain%2C%20clean%20magazine%20aesthetic%2C%20tranquil%20composition%2C%20no%20text&width=480&height=360&seq=peach-feed-01&orientation=landscape',
  },
  {
    time: '38 分钟前',
    filter: '争议中',
    title: '某联名周边发货延迟：预售页面与实物规格对照',
    summary:
      '有用户对比出 3 处规格差异，品牌方称属于批次差异，已开放无理由退换通道。',
    tags: ['争议', '对照清单'],
    heat: '3.6万',
    cover:
      'https://readdy.ai/api/search-image?query=Blush%20and%20coral%20editorial%20abstract%20still%20life%20on%20creamy%20backdrop%2C%20soft%20ceramic%20object%20and%20folded%20paper%2C%20mild%20studio%20lighting%2C%20fine%20grain%2C%20refined%20magazine%20quality%2C%20serene%20balanced%20layout%2C%20no%20text&width=480&height=360&seq=peach-feed-02&orientation=landscape',
  },
  {
    time: '1 小时前',
    filter: '扒皮纪实',
    title: '某赛事判罚争议：官方复核结论与选手陈述并列',
    summary:
      '复核报告给出 2 项维持原判的说明，选手方则补充了现场另一机位的画面作为参考。',
    tags: ['扒皮', '多方说法'],
    heat: '5.9万',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20editorial%20abstract%20composition%20on%20pale%20cream%20background%2C%20stacked%20matte%20paper%20layers%20and%20a%20thin%20ribbon%2C%20soft%20daylight%2C%20subtle%20film%20grain%2C%20quiet%20luxury%20magazine%20mood%2C%20no%20text&width=480&height=360&seq=peach-feed-03&orientation=landscape',
  },
  {
    time: '2 小时前',
    filter: '待证实',
    title: '某短视频账号争议：截图的完整上下文仍在核对中',
    summary:
      '流传截图只覆盖部分对话，完整记录尚未公开，目前双方均未给出正式说明。',
    tags: ['待证实', '证据核对'],
    heat: '6.4万',
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20apricot%20editorial%20abstract%20detail%20on%20a%20warm%20cream%20surface%2C%20subtle%20paper%20folds%20and%20a%20small%20stone%20token%2C%20gentle%20diffused%20lighting%2C%20fine%20grain%2C%20elegant%20minimal%20magazine%20aesthetic%2C%20no%20text&width=480&height=360&seq=peach-feed-04&orientation=landscape',
  },
  {
    time: '3 小时前',
    filter: '已有结论',
    title: '某品牌客服致电录音争议：官方说明与处理结果',
    summary:
      '品牌方公布内部核查结论并致歉，涉事客服岗位调整，相关流程已补充录音留存要求。',
    tags: ['实锤', '官方回应'],
    heat: '7.7万',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20rose%20and%20cream%20editorial%20abstract%20still%20life%2C%20delicate%20paper%20sheet%20and%20a%20matte%20ceramic%20dish%2C%20soft%20studio%20lighting%2C%20subtle%20grain%20texture%2C%20premium%20magazine%20cover%20aesthetic%2C%20calm%20composition%2C%20no%20text&width=480&height=360&seq=peach-feed-05&orientation=landscape',
  },
  {
    time: '5 小时前',
    filter: '今日更新',
    title: '某活动临时改期事件：通知时间线与补偿口径整理',
    summary:
      '改期通知的发布时间与购票时间存在重叠区间，主办方就补偿范围给出补充说明。',
    tags: ['时间线整理', '持续跟进'],
    heat: '3.1万',
    cover:
      'https://readdy.ai/api/search-image?query=Peach%20and%20sand%20toned%20editorial%20abstract%20scene%20on%20a%20creamy%20backdrop%2C%20layered%20paper%20cards%20and%20soft%20fabric%2C%20mild%20natural%20lighting%2C%20fine%20grain%2C%20understated%20luxury%20magazine%20composition%2C%20no%20text&width=480&height=360&seq=peach-feed-06&orientation=landscape',
  },
];

export const timelineEvents = [
  {
    date: '08-19',
    title: '争议首次出现',
    desc: '一条只含部分内容的对话截图开始流传，讨论集中在截图是否完整。',
    status: '待证实',
  },
  {
    date: '08-23',
    title: '当事方首次回应',
    desc: '当事方发布说明，强调截图缺失上下文，并表示会整理完整记录。',
    status: '多方回应',
  },
  {
    date: '08-27',
    title: '第三方补充材料',
    desc: '有账号贴出另一角度的时间线整理，与首次说法在时间点上存在出入。',
    status: '出现出入',
  },
  {
    date: '09-02',
    title: '平台方介入核查',
    desc: '平台方发布核查说明，公开了部分后台记录，但未涉及全部争议点。',
    status: '官方核查',
  },
  {
    date: '09-08',
    title: '仍有疑点待解',
    desc: '两处关键时间点尚未对齐，事件仍在持续跟进中，暂无最终结论。',
    status: '跟进中',
  },
];

export const angleViews = [
  {
    side: '当事方说法',
    tone: 'primary',
    points: [
      '流传材料缺少前后文，单独引用会产生误解',
      '已整理完整记录，将在合适时机公布',
      '对涉及隐私的部分内容保留法律意见',
    ],
  },
  {
    side: '旁观者说法',
    tone: 'secondary',
    points: [
      '时间线比对后发现两处对不上',
      '部分截图存在裁剪，需要原始文件佐证',
      '讨论热度高于信息量，建议先看材料再判断',
    ],
  },
  {
    side: '平台方说法',
    tone: 'accent',
    points: [
      '已核查关联账号的操作记录',
      '未发现系统性异常，个别环节仍在复核',
      '相关处理结果会同步到事件页更新中',
    ],
  },
];

export const topics = [
  { name: '商业纠纷', count: 412 },
  { name: '节目剪辑', count: 286 },
  { name: '直播带货', count: 233 },
  { name: '票房数据', count: 178 },
  { name: '演出退改', count: 165 },
  { name: '品牌客服', count: 152 },
  { name: '选秀赛制', count: 141 },
  { name: '代言解约', count: 133 },
  { name: '版权署名', count: 121 },
  { name: '平台规则', count: 108 },
  { name: '赛事判罚', count: 97 },
  { name: '周边发货', count: 84 },
];